import cn from 'classnames';
import React from 'react';
import { FocusArea, useImageQuery } from '~/client/hooks/use-image-query';
import Blur from '../blur/blur';
import type { BackgroundImage as Props } from './background-image.types';

/**
 * 150/85 default values for defaultHeight and defaultWidth roughly equals 16/9
 */
const ContentfulBackgroundImage: React.FunctionComponent<Props> = ({
  className,
  defaultHeight = 85,
  defaultWidth = 150,
  focusArea,
  src,
}) => {
  const [setElement, query] = useImageQuery(
    defaultWidth,
    defaultHeight,
    focusArea
  );

  return (
    <div
      aria-hidden
      className={cn(
        'background-image',
        'background-image--contentful',
        className
      )}
      ref={setElement}
      style={{ backgroundImage: `url(${src}${query})` }}
    >
      <Blur />
    </div>
  );
};

/**
 * BackgroundImage needs to be rendered inside a parent element which has non-static positioning.
 */
const BackgroundImage: React.FunctionComponent<Props> & {
  focusAreas: typeof FocusArea;
} = ({ provider = 'contentful', ...props }) =>
  provider === 'contentful' ? (
    <ContentfulBackgroundImage {...props} />
  ) : (
    <div
      aria-hidden
      className={cn(
        'background-image',
        `background-image--${provider}`,
        props.className
      )}
      style={{ backgroundImage: `url(${props.src})` }}
    >
      <Blur />
    </div>
  );

BackgroundImage.focusAreas = FocusArea;

export default BackgroundImage;
